<div class="paginator-container">
  <p class="secondary-text align-text-vertically"> {{ from }} - {{ to }} from {{ length }}</p>
  <div class="buttons">
    <button mat-icon-button [disabled]="!isFirstPage" (click)="onPreviousPage()">
      <mat-icon [ngClass]="!isFirstPage ? 'paginator-arrow-icon-disabled' : 'paginator-arrow-icon'">
        keyboard_arrow_left
      </mat-icon>
    </button>
    <button mat-icon-button [disabled]="!isLastPage" (click)="onNextPage()">
      <mat-icon [ngClass]="!isLastPage ? 'paginator-arrow-icon-disabled' : 'paginator-arrow-icon'">
        keyboard_arrow_right
      </mat-icon>
    </button>
  </div>
</div>
